export const error = ({ to, from, next, store }) => {
    if (!store.getters['error/isError']) return next();
    if (!from.name) {
        return to.name === 'Accueil' ? next() : next({ path: '/', name: 'Accueil'})
    }
    if (process.env.VUE_APP_AUTO_REDIRECT !== 'true' && from.name) return next(from)
    const route = store.getters['error/route'];
    store.dispatch('error/reset');
    return next(route);
}

export default { error };